export class Usage {
    public ToolUsageDescription: string = "";
    public GlobalRegionId: string = "";
    public PlantId: string = "";
    public ProgramId: string = "";
    public ModelYearId: string = "";
    public Quantity: number = 1;
    public Station: string = "";
    public DesignSource: string = "";
    public BuildSource: string = "";
    public IsActive: boolean = true;
    public ToolId: any = "";
    TeamCenterLink: any = "";
    ReferenceLinkName: any = "";
    ReferenceLinkURL: any = "";
}